module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex_samples/pattern_d4/sec01_sp_914bf3e50f9af68f5e820784429da01a.jpg";